import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Version } from '@nimmsta/ng-commons-lib/models';
import { VersionService } from '@nimmsta/ng-commons-lib/services/version';
import { DefaultLayoutComponent } from '@nimmsta/ng-commons-lib/default-layout';
import { DefaultMenuComponent } from '@nimmsta/ng-commons-lib/menu';
import { environment } from '../../environments/environment';
import { VERSION } from '../../environments/version';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

_('dashboard.nav');
_('devices.nav');
_('reports.defectReport.nav');
_('configurations.nav');
_('organizations.nav');
_('user.nav');
_('request-access.nav');
_('contents.nav');
_('batchItems.nav');

@Component({
  standalone: true,
  imports: [CommonModule, DefaultLayoutComponent, DefaultMenuComponent],
  templateUrl: './layout.component.html',
})
export class LayoutComponent {
  protected _sidebarCollapsed = false;
  protected _mobileNavExpanded = false;
  frontendVersion?: Version = VERSION;
  backendVersion?: Version;

  private versionService = inject(VersionService);

  constructor() {
    this.versionService.setBaseURL(`${environment.apiUrls.b2b}/api`);
    this.versionService.getBackendVersion().subscribe((version) => {
      this.backendVersion = version;
    });
  }

  updateMobileNavExpanded(expanded: boolean) {
    this._mobileNavExpanded = expanded;
  }

  updateSidebarCollapsed(collapsed: boolean) {
    this._sidebarCollapsed = collapsed;
  }
}
